<div id="general" class="category-content active">
    <div class="stats-grid">
        <div class="stat-card">
            <span class="stat-number">88</span>
            <div class="stat-label">Jugadores Inscritos</div>
        </div>
        <div class="stat-card">
            <span class="stat-number">11</span>
            <div class="stat-label">Categorias</div>
        </div>
        <div class="stat-card">
            <span class="stat-number">6</span>
            <div class="stat-label">Clubes</div>
        </div>
    </div>

    <div class="rules-grid">
        <div class="rule-card">
            <div>
                <svg width="80px" height="80px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 17V11" stroke="#ff6b35" stroke-width="1.5" stroke-linecap="round" />
                    <circle cx="1" cy="1" r="1" transform="matrix(1 0 0 -1 11 9)" fill="#ff6b35" />
                    <path
                        d="M7 3.33782C8.47087 2.48697 10.1786 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 10.1786 2.48697 8.47087 3.33782 7"
                        stroke="#ff6b35" stroke-width="1.5" stroke-linecap="round" />
                </svg>
            </div>
            <div class="rule-list">
                <ul>
                    <li>Todos los partidos se jugarán a 2 de 3 games.</li>
                    <li>Uso de gafas es obligatorio</li>
                    <li>El buen comportamiento es fundamental para el buen desarrollo del torneo la buena conducta deportiva hace que nuestro deporte sea más sano y familiar tanto para deportistas como padres de familia o acompañantes</li>
                    <li>La programación está diseñada por bloques de horas, por favor llegar puntual a sus partidos (los jugadores deben asegurar presencia en el rango de la categoría que le corresponde). </li>
                </ul>
            </div>
        </div>
    </div>

    <h3 style="margin-bottom: 20px; color: #ff6b35; text-align: center;">Programación por bloques</h3>

    <div class="tab-content" style="display: block; margin-bottom: 2rem;">
        <div class="info-schedule">
            <h3 style="margin-bottom: 20px; color: #ff6b35;">Lunes 15 de Septiembre</h3>
            <div class="info">
                <div class="time"><span>desde</span>04:30 p.m. <br><span>hasta</span>05:30 p.m.</div>
                <div class="players">Infantil</div>
            </div>
            <div class="info">
                <div class="time"><span>desde</span>05:30 p.m. <br><span>hasta</span>06:30 p.m.</div>
                <div class="players">Juvenil</div>
            </div>
            <div class="info">
                <div class="time"><span>desde</span>06:30 p.m. <br><span>hasta</span>07:30 p.m.</div>
                <div class="players">Tercera - Cuarta</div>
            </div>
            <div class="info">
                <div class="time"><span>desde</span>07:30 p.m. <br><span>hasta</span>08:30 p.m.</div>
                <div class="players">Damas - Sexta - Senior +35</div>
            </div>
        </div>

        <div class="info-schedule">
            <h3 style="margin-bottom: 20px; color: #ff6b35;">Martes 16 de Septiembre</h3>
            <div class="info">
                <div class="time"><span>desde</span>04:30 p.m. <br><span>hasta</span>05:30 p.m.</div>
                <div class="players">Infantil</div>
            </div>
            <div class="info">
                <div class="time"><span>desde</span>05:30 p.m. <br><span>hasta</span>06:30 p.m.</div>
                <div class="players">Juvenil</div>
            </div>
            <div class="info">
                <div class="time"><span>desde</span>06:30 p.m. <br><span>hasta</span>07:30 p.m.</div>
                <div class="players">Novatos - Segunda</div>
            </div>
            <div class="info">
                <div class="time"><span>desde</span>07:30 p.m. <br><span>hasta</span>08:30 p.m.</div>
                <div class="players">Quinta - Damas - Senior +35</div>
            </div>
        </div>

        <div class="info-schedule">
            <h3 style="margin-bottom: 20px; color: #ff6b35;">Miércoles 17 de Septiembre</h3>
            <div class="info">
                <div class="time"><span>desde</span>05:30 p.m. <br><span>hasta</span>06:30 p.m.</div>
                <div class="players">Novatos - Senior +35</div>
            </div>
            <div class="info">
                <div class="time"><span>desde</span>06:30 p.m. <br><span>hasta</span>07:30 p.m.</div>
                <div class="players">Quinta - Segunda</div>
            </div>
            <div class="info">
                <div class="time"><span>desde</span>07:30 p.m. <br><span>hasta</span>08:30 p.m.</div>
                <div class="players">Sexta - Tercera - Cuarta</div>
            </div>
        </div>

        <div class="info-schedule">
            <h3 style="margin-bottom: 20px; color: #ff6b35;">Jueves 18 de Septiembre</h3>
            <div class="info">
                <div class="time"><span>desde</span>05:00 p.m. <br><span>hasta</span>06:00 p.m.</div>
                <div class="players">Tercera- Cuarta - Senior +35</div>
            </div>
        </div>

        <div class="info-schedule">
            <h3 style="margin-bottom: 20px; color: #ff6b35;">Viernes 19 de Septiembre</h3>
            <div class="info">
                <div class="time"><span>desde</span>04:30 p.m.</div>
                <div class="players">Cuartos: Infantil - Juvenil</div>
            </div>
            <div class="info">
                <div class="time"><span>desde</span>05:00 p.m.</div>
                <div class="players">Cuartos: Quinta - Sexta - Novatos</div>
            </div>
            <div class="info">
                <div class="time"><span>desde</span>05:00 p.m.</div>
                <div class="players">Semifinal: Damas - Juvenil - Infantil</div>
            </div>
            <div class="info">
                <div class="time"><span>desde</span>06:30 p.m.</div>
                <div class="players">Semifinal: Quinta - Sexta - Novatos</div>
            </div>
            <div class="info">
                <div class="time"><span>desde</span>06:00 p.m.</div>
                <div class="players">Final: Tercera</div>
            </div>
            <div class="info">
                <div class="time"><span>desde</span>06:30 p.m.</div>
                <div class="players">Final: Senior +35 - Segunda - Cuarta - Juvenil - Infantil - Damas</div>
            </div>
            <div class="info">
                <div class="time"><span>desde</span>07:00 p.m.</div>
                <div class="players">Final: Quinta - Sexta - Novatos</div>
            </div>
        </div>
    </div>
</div>